module.exports = __webpack_public_path__ + "static/media/dolbycanyon1150515717.b2ed556a.m4v";